import React from 'react'
import { ScrollView, StyleSheet, View } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import MaterialCommunityIcons from '@expo/vector-icons/MaterialCommunityIcons'
import { StackActions, useNavigation } from '@react-navigation/native'
import { useKeepAwake } from 'expo-keep-awake'
import Text from 'theme/Text'
import Button from 'theme/Button'
import { StatusBar } from 'expo-status-bar'
import { AppRoutes } from 'navigations/app-routes'
import { useScannerFullScreen } from 'utils/hooks/use-scanner-full-screen'
import i18n from 'utils/i18n'

const HomeLunchSleepingIndexScene = () => {
	useKeepAwake();
	useScannerFullScreen();
	const navigation = useNavigation();
	const wakeUp = () => {
		navigation.dispatch( StackActions.replace( AppRoutes.LUNCH_SCANNER ) );
	};

	return (
		<SafeAreaView style={ styles.screen }>
			<StatusBar style="light" />
			<ScrollView contentContainerStyle={ styles.content }>
				<View style={ styles.panel }>
					<View style={ styles.icon } accessible={ false }>
						<MaterialCommunityIcons name="moon-waning-crescent" size={ 48 } color="#9ca3af" />
					</View>
					<Text style={ styles.brand }>{ i18n.t( 'app_name' ) }</Text>
					<Text style={ styles.title }>{ i18n.t( 'lunch_scanner.sleeping.text' ) }</Text>
					<Button onPress={ wakeUp }>{ i18n.t( 'lunch_scanner.sleeping.button' ) }</Button>
				</View>
			</ScrollView>
		</SafeAreaView>
	);
};

const styles = StyleSheet.create({
	screen: { flex: 1, backgroundColor: '#080a10' },
	content: { flexGrow: 1, alignItems: 'center', justifyContent: 'center', padding: 24 },
	panel: { width: '100%', maxWidth: 460, alignItems: 'stretch', gap: 24 },
	icon: { alignItems: 'center' },
	brand: { fontSize: 16, color: '#9ca3af', textAlign: 'center' },
	title: { fontSize: 26, fontWeight: '700', color: '#ffffff', textAlign: 'center' },
});

export default HomeLunchSleepingIndexScene;
